/**
 * Newsletter Component JS
 * Handles AJAX submission for Mailchimp subscription using delegated events.
 */

export const initNewsletter = () => {
    console.log('Newsletter Init called');
    if (window.newsletterInitialized) return;
    window.newsletterInitialized = true;

    // Handle all interactions via click and submit
    const handleSubmission = (e) => {
        const submitBtn = e.target.closest('.newsletter-submit');
        const form = e.target.closest('.newsletter-form');
        
        if (!submitBtn && e.type === 'click') return;
        if (!form) return;

        console.log('Newsletter interaction detected', e.type);
        e.preventDefault();
        e.stopPropagation(); // Prevent other listeners from interfering
        
        handleNewsletterSubmission(form);
    };

    document.addEventListener('submit', (e) => {
        if (e.target.closest('.newsletter-form')) {
            handleSubmission(e);
        }
    }, true);

    document.addEventListener('click', (e) => {
        if (e.target.closest('.newsletter-submit')) {
            handleSubmission(e);
        }
    }, true);
};

async function handleNewsletterSubmission(container) {
    const submitBtn = container.querySelector('.newsletter-submit');
    const statusBox = container.querySelector('.newsletter-status');
    const statusMsg = container.querySelector('.status-message');
    const emailInput = container.querySelector('input[name="email"]');
    
    console.log('Starting newsletter submission...');

    if (typeof bummed_ajax === 'undefined') {
        console.error('bummed_ajax is not defined!');
        return;
    }

    if (!emailInput || !emailInput.value || !emailInput.checkValidity()) {
        emailInput?.reportValidity();
        return;
    }

    const originalBtnText = submitBtn.innerHTML;

    // Reset status
    if (statusBox) statusBox.classList.add('opacity-0');

    // Disable UI
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="inline-block animate-spin mr-2">↻</span>' + originalBtnText;

    // Collect data
    const formData = new FormData();
    const inputs = container.querySelectorAll('input');
    inputs.forEach(input => {
        if (input.name) {
            formData.append(input.name, input.value);
        }
    });
    
    formData.append('action', 'bummed_subscribe_mailchimp');
    if (container.querySelector('input[name="nonce"]')) {
        formData.append('nonce', container.querySelector('input[name="nonce"]').value);
    }

    try {
        const response = await fetch(bummed_ajax.url, {
            method: 'POST',
            body: formData
        });

        const result = await response.json();
        console.log('Newsletter result:', result);

        if (result.success) {
            if (statusMsg) statusMsg.textContent = result.data.message;
            if (statusBox) statusBox.classList.add('opacity-100');
            
            // GA4: Subscription Successful
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'subscription_form_submit',
                'form_id': 'newsletter_footer'
            });

            // Clear email input only
            emailInput.value = '';
        } else {
            if (statusMsg) statusMsg.textContent = result.data.message || 'An error occurred.';
            if (statusBox) statusBox.classList.add('opacity-100');
        }
    } catch (error) {
        console.error('Newsletter Error:', error);
        if (statusMsg) statusMsg.textContent = 'Server error. Please try again later.';
        if (statusBox) statusBox.classList.add('opacity-100');
    } finally {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalBtnText;
    }
}
